import { AnimatePresence } from 'framer-motion'
import type { Release } from '../lib/changelog'
import { SheetPanel } from './SheetPanel'
import { wideBtn } from './sheetButtons'

interface Props {
  release: Release | null
  onClose: () => void
}

export function WhatsNewSheet({ release, onClose }: Props) {
  return (
    <AnimatePresence>
      {release && (
        <SheetPanel onClose={onClose} zIndex={20}>
          <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 6 }}>
            What’s new in {release.version}
          </h2>
          <p style={{ color: 'var(--ml-text-secondary)', fontSize: 14, marginBottom: 20 }}>
            You’re up to date.
          </p>

          <ul style={{ listStyle: 'none', marginBottom: 24, display: 'grid', gap: 12 }}>
            {release.notes.map((note) => (
              <li key={note} style={{ display: 'flex', gap: 10, fontSize: 15, lineHeight: 1.4 }}>
                <span style={{ color: 'var(--ml-accent-fg)' }}>•</span>
                <span>{note}</span>
              </li>
            ))}
          </ul>

          <button
            onClick={onClose}
            style={wideBtn}
          >
            Got it
          </button>
        </SheetPanel>
      )}
    </AnimatePresence>
  )
}
